<template>
  <footer class="container" v-if="bottom == 1">
    <div>
      <div class="bottom">
        <ul class="flex">
          <li>
            <router-link :to="aboutPath('about')" target="_blank">关于我们</router-link>
          </li>
          <li>
            <router-link :to="aboutPath('contactUs')" target="_blank">
              联系我们
            </router-link>
          </li>
          <li>
            <router-link :to="aboutPath('disclaimer')" target="_blank">
              免责声明
            </router-link>
          </li>
          <li>本站学术标签</li>
          <li @click="$router.push('/homeStationClassify')">本站分类法</li>
          <li>
            <router-link to="BigData" target="_blank">
              本站大数据
            </router-link>
          </li>
        </ul>
        <p>
          <span>
            版权所有 北京中科进出口有限责任公司
            <a
              :class="{ 'fair-link': isFair }"
              target="_blank"
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
            >
              京ICP备14031295号-5
            </a>
          </span>
          <span>技术支持 江苏畅想之星信息技术有限公司</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      index: 1,
      path: '',
      bottom: 2,
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.path = val.path
        if (val.name == 'nopage') {
          this.bottom = 2
        } else {
          this.bottom = 1
        }
        // if (
        //   val.name == 'managerhome' ||
        //   val.name == 'searchresult' ||
        //   val.name == 'noticdetail'
        // ) {
        //   this.bottom = 1
        // }
      },
    },
  },
  computed: {
    isFair() {
      const pathname = window.location.pathname
      return pathname === '/ic/'
    },
  },
  mounted() {},
  methods: {
    aboutPath(type) {
      return {
        path: '/BottomInfo',
        query: { type },
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  background: #333333;
  color: #999999;
  text-align: center;
  .footer {
    text-align: center;
    padding: 20px 0;
    span {
      cursor: pointer;
      &:nth-of-type(1) {
        margin-right: 20px;
      }
      &:nth-of-type(2) {
        margin-left: 20px;
      }
    }
  }
  .bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 30px 0;
    ul {
      justify-content: center;
      margin-bottom: 20px;
      li {
        margin: 0 20px;
        cursor: pointer;
        a {
          color: #999;
        }
      }
    }
  }
}
a {
  color: #999;
}
a:hover {
  color: #e68422;
}
.fair-link:hover {
  color: #08b4cf;
}
</style>



// WEBPACK FOOTER //
// src/views/bottom/index.vue